<nz-tabset [nzSelectedIndex]="currentIndex">
    <nz-tab *ngFor="let item of tabs; let i = index" [nzTitle]="titleTemplate" (nzClick)="changeTab(item, i)">
        <ng-template #titleTemplate>
            <em *ngIf="item.icon" nz-icon [nzType]="item.icon" class="tab-icon"></em>
            {{ item.name }}
            <span
                *ngIf="item.count || item.count === 0"
                class="count"
            >
                {{ item.count }}
            </span>
        </ng-template>
    </nz-tab>
</nz-tabset>
